const getUrl = () => {
  if (window.location.host.includes("localhost"))
    return "https://api.dev-um.universomedico.com.br";

  return window.location.host.replace("web", "api");
};

export default getUrl;



// WEBPACK FOOTER //
// ./src/helpers/getUrl.js